var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-message-box" }, [
    _c("img", {
      staticClass: "boss-message-box-avatar",
      attrs: { src: require("@/assets/images/avatar-company.svg") },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "boss-message-header-layout" }, [
      _c(
        "div",
        {
          staticClass: "boss-layout-block boss-message-when",
          attrs: { "data-test": "date" },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm._f("formatDate")(_vm.date)) + "\n      "
          ),
          _vm.isRead
            ? _c(
                "span",
                {
                  staticClass:
                    "boss-message-status-label boss-message-status-label-read",
                  attrs: { "data-test": "read" },
                },
                [_vm._v("既読")]
              )
            : _c(
                "span",
                {
                  staticClass: "boss-message-status-label",
                  attrs: { "data-test": "no-read" },
                },
                [_vm._v("未読")]
              ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c(
        "div",
        {
          staticClass: "boss-message-mail-subject",
          attrs: { "data-test": "subject" },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm._f("formatSubject")(_vm.subject)) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "boss-message-mail-body pega-pre-wrap",
        attrs: { "data-test": "body" },
        domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody)) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }